import { forwardRef } from 'react';

interface Props {
  className?: string;
}

const ClipboardCopy = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <svg
    ref={ref}
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M1.70795 13.8675H6.89521C8.03416 13.8675 8.609 13.3021 8.609 12.1783V7.92818H4.75276C4.04565 7.92818 3.7149 7.59861 3.7149 6.90872V3.01372H1.70795C0.571386 3.01372 0 3.58027 0 4.70291V12.1783C0 13.3067 0.569001 13.8675 1.70795 13.8675ZM4.75178 7.19179H8.50791C8.45407 6.98263 8.32623 6.78487 8.07675 6.53692L5.13502 3.60976C4.88673 3.3675 4.67699 3.20399 4.4638 3.14914V6.91082C4.4638 7.09549 4.56251 7.19179 4.75178 7.19179ZM9.35671 11.1807H9.57001C10.7031 11.1807 11.2838 10.6142 11.2838 9.49151V4.38956H8.22759C7.65395 4.38956 7.33011 4.06676 7.33011 3.51162V0.326904H4.38395C3.26493 0.326904 2.67482 0.893463 2.67482 1.97614V2.27734H3.47439C4.25038 2.27734 4.87362 2.45227 5.48667 3.05611L8.62275 6.10778C9.237 6.71278 9.35671 7.34135 9.35671 8.07678V11.1807ZM8.33527 3.71026H11.2201C11.1885 3.5422 11.0689 3.39243 10.8743 3.20271L8.54075 0.877893C8.35095 0.687007 8.1904 0.571483 8.02053 0.545161L8.02638 3.40202C8.02638 3.62199 8.11101 3.71026 8.33527 3.71026Z"
      fill="white"
    />
  </svg>
));

ClipboardCopy.displayName = 'ClipboardCopy';
export default ClipboardCopy;
